export const PostprocessorSettingFields = {
    "millingBottomGroove": "Фрезерование паза(обратная сторона)",
    "millingBottomNotch": "Фрезерование выемки(обратная сторона)",
    "millingDetailContour": "Фрезерование внешнего контура",
    "millingInnerContour": "Фрезерование внутреннего контура",
    "millingTopGroove": "Фрезерование паза",
    "millingTopNotch": "Фрезерование выемки",
    "cuttingBottomLongitudinalGroove": "Пиление продольного паза(обратная сторона)",
    "cuttingBottomTransverseGroove": "Пиление поперечного паза(обратная сторона)",
    "cuttingTopLongitudinalGroove": "Пиление продольного паза",
    "cuttingTopTransverseGroove": "Пиление поперечного паза",
    "drillingBackDiameters":"Диаметры дрелей для заднего торца",
    "drillingBottomDiameters":"Диаметры дрелей для нижней грани",
    "drillingFrontDiameters":"Диаметры дрелей для переднего торца",
    "drillingLeftDiameters":"Диаметры дрелей для левого торца",
    "drillingRightDiameters":"Диаметры дрелей для правого торца",
    "drillingTopDiameters":"Диаметры дрелей для верхней грани"
}